import React, { useCallback, useState } from 'react';
import { useRetryableObservable } from 'react-use-observable';

import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';
import TopPage from 'v2/components/Shared/TopPage';
import chargebackService from 'v2/services/chargeback';

import ChargebackDetails from './Details';
import Filter from './Filter';
import List from './List';
import Totalizers from './Totalizers';
import Breadcrumbs from '../Breadcrumbs';

const Chargeback = () => {
  const [, , , retryLoadChargeback] = useRetryableObservable(() => chargebackService.loadChargebacks(), []);

  const [visible, setVisible] = useState(false);
  const [invoiceId, setInvoiceId] = useState(undefined);

  const setModalVisible = useCallback((visible: boolean, invoiceId: number) => {
    setVisible(visible);
    setInvoiceId(invoiceId);
  }, []);

  const breadcrumbsLink = [
    {
      url: '/producer/reports/sales',
      name: 'Relatórios'
    }
  ];

  return (
    <>
      <ChargebackAlert />
      <Breadcrumbs navList={breadcrumbsLink} currentPage='Chargebacks' />

      <TopPage title='Chargebacks' extra='Gerencie os chargebacks solicitados pelos clientes.' disableAlerts />

      <Filter />
      <Totalizers />
      <List setModalVisible={setModalVisible} />
      {visible && (
        <ChargebackDetails
          retryLoadChargeback={retryLoadChargeback}
          visible={visible}
          invoiceId={invoiceId}
          setModalVisible={setModalVisible}
        />
      )}
    </>
  );
};

export default Chargeback;
